import { Component, OnInit, input } from "@angular/core";
import { CompositionStateEnum } from "../../../../core-ui/core-ui.enums";

@Component({
  selector: "app-composition-state",
  templateUrl: "./composition-state.component.html",
  styleUrls: ["./composition-state.component.scss"],
  standalone: false,
})
export class CompositionStateComponent implements OnInit {
  readonly state = input<CompositionStateEnum>(undefined);

  stateInitialized = CompositionStateEnum.initialized;
  stateAccepted = CompositionStateEnum.accepted;
  stateSubmitted = CompositionStateEnum.submitted;
  stateQueued = CompositionStateEnum.queued;
  stateProcessing = CompositionStateEnum.processing;
  stateDownloading = CompositionStateEnum.downloading;
  statePreprocessing = CompositionStateEnum.preprocessing;
  stateFinalizing = CompositionStateEnum.finalizing;
  stateCancelled = CompositionStateEnum.cancelled;
  stateFailed = CompositionStateEnum.failed;
  stateCompleted = CompositionStateEnum.completed;

  ngOnInit(): void {}
}
